import * as Actions from './../actions/types';

const initialState = {
  loading: false,
  catalogList: undefined
};

export const catalogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_CATALOG_LOADER:
      return {
        ...state,
        loading: action.payload
      };
    case Actions.SET_CATALOG_LIST:
      return {
        ...state,
        catalogList: action.payload
      };
    case Actions.CLEAR_CATALOG_DATA:
      return initialState;
    default:
      return state;
  }
};
